import ColoredIcon from '../ColoredIconAndChip/ColoredIcon';
import { STATUS_ICON_MAPPING, useStatusColor } from './constant';
import { TStatus } from './types';

export default function StatusIcon({
  status,
  iconSize = 'large',
}: Readonly<{
  status: TStatus;
  iconSize?: 'small' | 'inherit' | 'large' | 'medium';
}>) {
  const iconName = STATUS_ICON_MAPPING[status];
  const color = useStatusColor(status);

  return <ColoredIcon iconName={iconName} iconSize={iconSize} statusColor={color} />;
}
